var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("您所访问的页面未找到！ 您可以 ：")]),_c('p',[_c('a',{staticClass:"btn",attrs:{"href":"/"}},[_vm._v("返回首页")])])])
}]

export { render, staticRenderFns }